import React from 'react';
import { Button } from 'semantic-ui-react';
import { useAuth } from '../contexts/AuthContext';

function TestPage() {
  const { logout } = useAuth();

  const handleLogout = async () => {
    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const response = await fetch(`${apiUrl}/api/logout/`);
      if (!response.ok) {
        throw new Error('ネットワークレスポンスが異常です。');
      }
      const data = await response.json();
      console.log(data);
      await logout();
      window.location.href = '/login';
    } catch (error) {
      alert('ログアウトに失敗しました。');
    }
  };

  return (
    <div className="top-page">
      <h1>テストページ</h1>
      <p>ここはテストページのコンテンツが表示されます。</p>
      <Button primary onClick={handleLogout}>ログアウト</Button>
    </div>
  );
}

export default TestPage;